'use strict';

var h = require('virtual-dom/virtual-hyperscript');
var clickEvent = require('./lib/click-event.js');

var routeAtom = require('./router.js').atom;

module.exports = anchor;

function anchor(props, text) {
    props['ev-click'] = clickEvent(pushState, {
        ctrl: false,
        meta: false,
        rightClick: false
    });

    return h('a', props, text);

    function pushState() {
        routeAtom.set(props.href);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/mercury-router/anchor.js
// module id = 139
// module chunks = 0